module.exports = __webpack_public_path__ + "static/media/gold-partner5.d97e8f82.png";